import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/gcstudent/ourteem/OurTeam.css";

// Avatar illustrations (replace with your actual team member photos anytime)
import member1 from "../../../assets/images/avatar-riha.png";
import member2 from "../../../assets/images/avatar-esha.png";
import member3 from "../../../assets/images/avatar-maryam.png";

const team = [
  {
    id: 1,
    name: "Riha Batool",
    role: "Superadmin",
    img: member1,
  },
  {
    id: 2,
    name: "Esha Aslam",
    role: "Sub Admin",
    img: member2,
  },
  {
    id: 3,
    name: "Maryam Mushtaq",
    role: "Sub Admin",
    img: member3,
  },
];

const OurTeam = () => {
  const [visible, setVisible] = useState(false);
  const [cardVisible, setCardVisible] = useState([false, false, false]);
  const sectionRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const sectionObserver = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) sectionObserver.observe(sectionRef.current);

    const cardObservers = team.map((_, i) => {
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setCardVisible((prev) => {
              const updated = [...prev];
              updated[i] = true;
              return updated;
            });
          }
        },
        { threshold: 0.15 }
      );
      if (cardRefs.current[i]) obs.observe(cardRefs.current[i]);
      return obs;
    });

    return () => {
      sectionObserver.disconnect();
      cardObservers.forEach((o) => o.disconnect());
    };
  }, []);

  return (
    <section className="team-section" ref={sectionRef}>
      <Container className="team-container">

        {/* Header */}
        <div className={`team-header ${visible ? "header-animate" : ""}`}>
          <h2 className="team-title">Our Team</h2>
          <p className="team-subtitle">Meet the Librarian Admins Of GGCW Library</p>
        </div>

        {/* Cards */}
        <Row className="justify-content-center gy-3 gx-3">
          {team.map((member, i) => (
            <Col key={member.id} xs={12} sm={6} md={4} lg={3}>
              <div
                className={`team-card ${cardVisible[i] ? "card-animate" : ""}`}
                ref={(el) => (cardRefs.current[i] = el)}
                style={{ transitionDelay: `${i * 0.14}s` }}
              >
                <div className="team-img-wrapper">
                  <img
                    src={member.img}
                    alt={member.name}
                    className="team-img"
                  />
                </div>
                <h5 className="team-name">{member.name}</h5>
                <p className="team-role">{member.role}</p>
              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default OurTeam;